export type ChangeStep = 'Timing' | 'Reservation Handling' | 'Review';

export type ChangeTiming = 'TOMORROW' | 'WHEN_ENDS';
export type ReservationChoice = 'KEEP' | 'DELETE';

export const ALL_CHANGE_STEPS: ChangeStep[] = ['Timing', 'Reservation Handling', 'Review'];
